import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["object"],
    properties: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "properties", {
            groupID,
            eLynxObject
        }
    ],
    propertyLists: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "property-lists", {
            groupID,
            eLynxObject
        }
    ],
    commData: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "object-comm-data", {
            groupID,
            eLynxObject
        }
    ]
};
